import config from "./config";
var axios = config();

export default {
  getCommunityPartnerContact(id) {
    return axios.get("/api/CommunityPartnerContacts/" + id);
  },

  createCommunityPartnerContact(communityPartnerContact) {
    return axios.post(
      "/api/CommunityPartnerContacts/",
      communityPartnerContact
    );
  },

  updateCommunityPartnerContact(communityPartnerContact) {
    return axios.put(
      "/api/CommunityPartnerContacts/" + communityPartnerContact.id,
      communityPartnerContact
    );
  },

  getContactTypes() {
    return axios.get("/api/ContactTypes");
  },

  getByTag(tagId) {
    return axios.get("/api/CommunityPartnerContacts/tag/" + tagId);
  }
};
